import { Component, Injector, Input, OnInit } from '@angular/core';
import { Configuration, ConfigurationsGroup } from '../models/configuration';
import { ModelField } from '@app/shared/interfaces/front-end-column';
import { Scope } from '@app/shared/interfaces/Attribute';
import { FormControl, FormGroup } from '@angular/forms';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';

@Component({
  selector: 'app-configuration-group',
  templateUrl: './configuration-group.component.html',
  styleUrls: ['./configuration-group.component.less'],
})
export class ConfigurationGroupComponent
  extends BaseComponent
  implements OnInit
{
  private _group: ConfigurationsGroup;
  fields: ModelField[] = [];
  formGroup: FormGroup;
  @Input() set configurationsGroup(group: ConfigurationsGroup) {
    this._group = group;
    if (group != null) {
      this.formGroup = this.fb.group({});
      this.fields = this.prepareFields(group.configurations);
      this.fields.forEach((field) => {
        const value = this._group.configurations.find(
          (x) => x.code == field.Code.toString()
        )?.value;
        this.formGroup.addControl(
          field.Code.toString(),
          new FormControl(value ?? null)
        );
      });
    }
  }
  get configurationsGroup() {
    return this._group;
  }

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {}

  prepareFields(configs: Configuration[]): ModelField[] {
    return configs.map((config) => {
      const field: ModelField = {
        Code: config.code,
        DataType: Number(config.type || 0),
        Scope: Scope.Global,
        Title: config.descibtion,
      };
      return field;
    });
  }

  submitGroup() {
    const value = this.formGroup.value;
    this.configurationService.put(value).subscribe(() => {
      this.message.success(
        `${this.configurationsGroup.name} configurations updated successfully`
      );
    });
  }
}
